import type { LanguageCodeEnum, OrdersQuery } from '@/graphql/saleor/api';
import { fetchOrderData } from '@/lib/order';
import { paths } from '@/lib/paths';

export const checkIsOrderPaid = async (
  id: string,
  languageCode: LanguageCodeEnum,
) => {
  const res = await fetchOrderData(id, languageCode);
  const order = res.data.order;

  if (!order) return false;

  const paidAmount =
    (order.totalAuthorized?.amount || 0) + (order.totalCharged?.amount || 0);

  return paidAmount > 0;
};

export const getUserCheckout = async (userEmail: string, channel: string) => {
  const queryParams = new URLSearchParams({
    userEmail,
    channel,
  });

  try {
    const result = await fetch(`/api/checkouts/user?${queryParams}`);

    if (!result.ok) {
      return null;
    }

    const data = await result.json();
    return data?.checkout;
  } catch (error) {
    console.error('Error fetching user checkout:', error);
    return null;
  }
};

export const getCheckoutOrderId = async (checkoutId: string) => {
  try {
    const result = await fetch(
      paths.api.order.getByCheckout.asPath({
        query: { checkoutId },
      }),
    );

    if (!result.ok) {
      return null;
    }

    const { data } = await result.json();
    return data?.orders?.edges?.[0]?.node.id;
  } catch (error) {
    console.error('Error fetching user checkout:', error);
    return null;
  }
};

export const getCheckoutOrders = async (checkoutId: string) => {
  try {
    const result = await fetch(
      paths.api.order.getByCheckout.asPath({
        query: { checkoutId },
      }),
    );

    if (!result.ok) {
      return null;
    }

    const { data } = await result.json();
    return data?.orders?.edges as NonNullable<OrdersQuery['orders']>['edges'];
  } catch (error) {
    console.error('Error fetching user checkout:', error);
    return null;
  }
};
